// extracted by mini-css-extract-plugin
export var gifts = "style-module--gifts--49e78";
export var policy = "style-module--policy--a49b9";
export var reg = "style-module--reg--9ee2c";